export default __webpack_public_path__ + "static/Fonts-f7af7a7f46884a76a4f6a4b9685435bb.png";